import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Shown when a signed-in admin opens a module their role does not include —
 * typically by typing the URL, since the menu hides what they cannot use.
 */
const Forbidden = () => {
    const navigate = useNavigate();

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div className="app-content flex-column-fluid">
                <div className="app-container container-xxl">
                    <div className="card">
                        <div className="card-body text-center py-20">
                            <i className="bi bi-shield-lock fs-3x text-gray-400 mb-5"></i>
                            <h1 className="text-gray-800 mb-3">Access Denied</h1>
                            <p className="text-gray-600 mb-8">
                                You do not have permission to view this module. Contact an
                                administrator if you believe this is a mistake.
                            </p>
                            <button className="btn btn-primary" onClick={() => navigate(-1)}>
                                Go Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Forbidden;
